import { usePatientResidentRegistrationNumberContext } from '@context/PatientResidentRegistrationNumber';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';

import { RRN_INPUT_VIEW } from '../focuskey';
import ButtonContainer from './components/ButtonContainer';
import Content from './components/Content';
import InputContainer from './components/InputContainer';

import * as styles from './styles';

const PatientResidentRegistrationNumberView = () => {
  const { focusRRNInput } = usePatientResidentRegistrationNumberContext();
  const { ref } = useFocusable({ focusKey: RRN_INPUT_VIEW });

  useEffect(() => {
    focusRRNInput();
  }, [focusRRNInput]);

  return (
    <FocusContext.Provider value={RRN_INPUT_VIEW}>
      <div css={styles.container} ref={ref}>
        <Content />
        <div css={styles.rightSideContainer}>
          <InputContainer />
          <ButtonContainer />
        </div>
      </div>
    </FocusContext.Provider>
  );
};

export default PatientResidentRegistrationNumberView;
